<template>
	<Layouts>
		<!-- ここに画面のタイトルを入力する -->
		<template v-slot:title>
			<div class="flex items-start justify-between">
				<div class="contents_header">
					<Title
						:title="'KIZUNA 顧客管理一覧'"
						:text="''"
						:icon="'fa-address-book'"
					/>
				</div>
				<Button
					:button-type="'button'"
					:button-class="'button-red'"
					:button-icon="'fa-pen'"
					:button-text="'新規作成'"
					@click="pageMove('create')"
				/>
			</div>
		</template>
		<!-- ここにコンテンツを入力する -->
		<template v-slot:contents>
			<div>
				<div class="bg-color-white2 sticky top-[70px] z-[10] pt-8">
					<div class="flex items-center">
						<SearchInput
							v-model="searchData.keyword"
							:form-class="'w-[34rem] min-w-[34rem]'"
							:placeholder="'企業名で検索'"
							@search-clear="searchClear('keyword')"
						/>
						<div class="ml-8 min-w-[25rem]">
							<CheckboxArray
								v-model="searchData.type"
								:checkbox-item="typeEnum"
							/>
						</div>

						<details
							class="searchAccordion ml-5 min-w-[700px] max-w-[700px]"
							:open="isSearchMenuOpenFlag"
							v-click-outside="searchMenuClose"
						>
							<summary @click="searchMenuOpen">
								<div
									class="tab:flex-col tab:items-start flex w-full items-center justify-between"
								>
									<div class="text-[14px] font-normal">
										<i
											class="fa-solid fa-magnifying-glass fa-fw mr-1"
										/>絞り込み条件を追加する
									</div>
								</div>
							</summary>
							<div class="searchAccordion_inner">
								<div class="flex">
									<div class="w-full">
										<FormTitle :text="'状態'" />
										<SearchSelect
											v-model="searchData.status"
											:form-class="''"
											:enum="salesEnums.status"
											:name="'status'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'架電結果'" />
										<SearchSelect
											v-model="searchData.call_result"
											:form-class="''"
											:enum="salesEnums.call_result"
											:name="'call_result'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'見込み'" />
										<SearchSelect
											v-model="searchData.estimate"
											:form-class="''"
											:enum="salesEnums.estimate"
											:name="'estimate'"
											@search-clear="searchClear"
										/>
									</div>
								</div>

								<div class="mt-8 flex">
									<div class="w-full">
										<FormTitle :text="'見込みなし'" />
										<SearchSelect
											v-model="searchData.no_estimate"
											:form-class="''"
											:enum="salesEnums.no_estimate"
											:name="'no_estimate'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'商談後状況'" />
										<SearchSelect
											v-model="searchData.post_meeting_status"
											:form-class="''"
											:enum="salesEnums.post_meeting_status"
											:name="'post_meeting_status'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'管理方法'" />
										<SearchSelect
											v-model="searchData.management_method"
											:form-class="''"
											:enum="salesEnums.management_method"
											:name="'management_method'"
											@search-clear="searchClear"
										/>
									</div>
								</div>

								<div class="mt-8 flex">
									<div class="w-full">
										<FormTitle :text="'特定技能有無'" />
										<SearchSelect
											v-model="searchData.has_specific_skill"
											:form-class="''"
											:enum="salesEnums.isOrIsnt"
											:name="'has_specific_skill'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'商談月'" />
										<MonthPicker
											v-model="searchData.meeting_month"
											:title="''"
											:form-class="'w-rem-20'"
											:required="false"
											:disabled="false"
											:error-text="''"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'申込月'" />
										<MonthPicker
											v-model="searchData.application_month"
											:title="''"
											:form-class="'w-rem-20'"
											:required="false"
											:disabled="false"
											:error-text="''"
										/>
									</div>
								</div>

								<div class="mt-8 flex">
									<div class="w-full">
										<FormTitle :text="'利用状況'" />
										<SearchSelect
											v-model="searchData.usage_status"
											:form-class="''"
											:enum="salesEnums.usage_status"
											:name="'usage_status'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'解約理由'" />
										<SearchSelect
											v-model="searchData.cancellation_reason"
											:form-class="''"
											:enum="salesEnums.cancellation_reason"
											:name="'cancellation_reason'"
											@search-clear="searchClear"
										/>
									</div>
									<div class="ml-8 w-full">
										<FormTitle :text="'資料ダウンロードの有無'" />
										<SearchSelect
											v-model="searchData.download_document"
											:form-class="''"
											:enum="salesEnums.isOrIsnt"
											:name="'download_document'"
											@search-clear="searchClear"
										/>
									</div>
								</div>

								<div class="mt-8 flex">
									<div class="w-full">
										<FormTitle :text="'資料ダウンロード月'" />
										<MonthPicker
											v-model="searchData.download_month"
											:title="''"
											:form-class="'w-rem-20'"
											:required="false"
											:disabled="false"
											:error-text="''"
										/>
									</div>
									<div class="ml-8 w-full"></div>
									<div class="ml-8 flex w-full items-end justify-end">
										<button
											type="button"
											class="searchButton"
											@click="searchAllClear"
										>
											<i
												class="fa-solid fa-rotate-right fa-fw fa-lg ml-1"
											/>条件クリア
										</button>
										<button
											type="button"
											class="searchButton close ml-4"
											@click="searchMenuClose"
										>
											<i class="fa-solid fa-xmark fa-fw fa-lg ml-1" />閉じる
										</button>
									</div>
								</div>
							</div>
						</details>
					</div>

					<Pagination
						:meta="pageNationMeta"
						:links="pageNationLinks"
						class="py-4"
						:page-class="'items-end'"
						@selected-link="selectedLink"
					/>
				</div>

				<table class="mt-4 table">
					<thead>
						<tr>
							<th class="table_title w-[120px] rounded-tl-[5px]">タイプ</th>
							<th class="table_title w-[10%]">法人番号</th>
							<th class="table_title w-[22%]">企業名</th>
							<th class="table_title w-[22%]">住所</th>
							<th class="table_title w-[10%]">電話番号</th>
							<th class="table_title w-[8%]">代表者名</th>
							<th class="table_title w-[10%]">担当者名</th>
							<th class="table_title w-[8%] rounded-tr-[5px]">登録日</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(item, index) in companiesList"
							@click="pageMove(item.id)"
						>
							<td class="table_data">
								<div class="flex">
									<div
										class="table_data_type mr-4"
										:class="item.type == 2 ? 'disabled' : ''"
									>
										技能
									</div>
									<div
										class="table_data_type green"
										:class="item.type == 1 ? 'disabled' : ''"
									>
										特定
									</div>
								</div>
							</td>
							<td
								class="table_data break-words"
								:class="item.corporate_number ? '' : 'text-color-gray3'"
							>
								{{ item.corporate_number ?? "未設定" }}
							</td>
							<td class="table_data">
								<b>{{ item.company_name }}</b>
							</td>
							<td
								class="table_data"
								:class="item.address ? '' : 'text-color-gray3'"
							>
								<div class="table_data_clamp">
									{{ item.address ?? "未設定" }}
								</div>
							</td>
							<td
								class="table_data"
								:class="item.tel ? '' : 'text-color-gray3'"
							>
								{{ item.tel ?? "未設定" }}
							</td>
							<td
								class="table_data"
								:class="item.name ? '' : 'text-color-gray3'"
							>
								{{ item.name ?? "未設定" }}
							</td>
							<td class="table_data">
								<div v-if="item.skill_staff_name">
									<span class="staffIcon">技</span>{{ item.skill_staff_name }}
								</div>
								<div v-if="item.spec_skill_staff_name">
									<span class="staffIcon green">特</span
									>{{ item.spec_skill_staff_name }}
								</div>
								<div
									v-if="!item.skill_staff_name && !item.spec_skill_staff_name"
									class="text-color-gray3"
								>
									未設定
								</div>
							</td>
							<td class="table_data">
								{{ item.created_at }}
							</td>
						</tr>
					</tbody>
				</table>
				<div
					v-if="companiesList && companiesList.length == 0"
					class="bg-color-blue1 mt-4 rounded-[5px] p-4 text-center"
				>
					<i
						class="fas fa-solid fa-face-grimace fa-fw fa-lg mr-2"
					/>該当者がいませんでした。
				</div>
				<Pagination
					v-if="companiesList && companiesList.length != 0"
					:meta="pageNationMeta"
					:links="pageNationLinks"
					:page-class="'item-start'"
					class="mt-4"
					@selected-link="selectedLink"
				/>
			</div>
		</template>
	</Layouts>
</template>
<script setup>
// 入力
import Button from "@/components/atoms/Button.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import Pagination from "@/components/atoms/Pagination.vue";
import SearchInput from "@/components/atoms/SearchInput.vue";
import SearchSelect from "@/components/atoms/SearchSelect.vue";
import Title from "@/components/atoms/Title.vue";
import Layouts from "@/components/layouts/Layouts.vue";
import CheckboxArray from "@/components/molecules/form/CheckboxArray.vue";
import MonthPicker from "@/components/molecules/form/MonthPicker.vue";
import * as salesEnums from "@/enums/SalesEnums.js";
import router from "@/router/index.js";
import { useIntersectionObserver } from "@vueuse/core";
import _ from "lodash";
import { onMounted, ref, watch } from "vue";
// store
import { useAuthStore } from "@/stores/AuthStore";
import { usePartsStore } from "@/stores/PartsStore";
// api
import FunctionApi from "@/api/FunctionApi.js";
// utils
import scrollControl from "@/utils/ScrollControl.js";
import toaster from "@/utils/Toaster.js";
// stubs

const authStore = useAuthStore();
const partsStore = usePartsStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { scrollStop, parentScrollRemove, parentScrollUnlock } = scrollControl();
const { alert } = toaster();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const searchData = ref({
	page: 1,
	keyword: "",
	type: [],
	status: "",
	call_result: "",
	estimate: "",
	no_estimate: "",
	post_meeting_status: "",
	management_method: "",
	has_specific_skill: "",
	meeting_month: "",
	application_month: "",
	usage_status: "",
	cancellation_reason: "",
	download_document: "",
	download_month: ""
});

const typeEnum = ref({
	1: "技能",
	2: "特定",
	3: "全て"
});

const companiesList = ref([]);
const pageNationMeta = ref([]);
const pageNationLinks = ref([]);
const isSearchMenuOpenFlag = ref(false);
const errors = ref([]);
const initialLoad = ref(true);
const observerElement = ref(null);
const pageResetStopFlag = ref(false);

/* ---------------------------------------------------------------------------
詳細取得
---------------------------------------------------------------------------- */
useIntersectionObserver(
	observerElement,
	([entry]) => {
		// 初回はスキップ
		if (initialLoad.value) {
			initialLoad.value = false;
			return;
		}
		if (entry.isIntersecting) {
			getcompaniesList();
		}
	},
	{ threshold: 1.0 }
);

// 顧客一覧取得
async function getcompaniesList() {
	await functionApi.company.list(searchData.value).then(res => {
		pageNationMeta.value = res.meta;
		pageNationLinks.value = res.links;
		companiesList.value = res.data;

		router.replace({ query: searchData.value });
	});
}
/* ---------------------------------------------------------------------------
	ページ切り替え
---------------------------------------------------------------------------- */
function selectedLink(link) {
	if (link.label == "前") {
		searchData.value.page = parseInt(searchData.value.page) - 1;
		getcompaniesList();
	} else if (link.label == "次") {
		searchData.value.page = parseInt(searchData.value.page) + 1;
		getcompaniesList();
	} else {
		searchData.value.page = link.label;
		getcompaniesList();
	}
}
/* ---------------------------------------------------------------------------
	絞り込み検索
---------------------------------------------------------------------------- */
// 検索開始
const searchFetch = _.debounce(() => {
	if (searchData.value.dateType == 1 && formatData.value != "") {
		searchData.value.day = getCurrentDay();
	}

	initialLoad.value = true;
	partsStore.scrollLoader = true;
	companiesList.value = [];
	// 検索が保持されていたら、ページをリセットは行わない
	if (pageResetStopFlag.value) {
		pageResetStopFlag.value = false;
		getcompaniesList();
	} else {
		searchData.value.page = 1;
		getcompaniesList();
	}
}, 300);

// セッションストレージにデータを保存する関数
function saveSearchDataToSession() {
	sessionStorage.setItem("searchData", JSON.stringify(searchData.value));
}

function saveListSession() {
	sessionStorage.setItem("saveList", JSON.stringify(companiesList.value));
}

// ページに戻ってきたときに、セッションストレージからデータを取得してセットする
function loadSearchDataFromSession() {
	const savedData = sessionStorage.getItem("searchData");
	if (savedData) {
		pageResetStopFlag.value = true;
		searchData.value = JSON.parse(savedData);
	} else {
		getcompaniesList();
	}
}

// searchDataが変わるたびにセッションストレージに保存
watch(searchData, saveSearchDataToSession, { deep: true });
watch(() => searchData.value.keyword, searchFetch);
watch(() => searchData.value.type, searchFetch);
watch(() => searchData.value.status, searchFetch);
watch(() => searchData.value.call_result, searchFetch);
watch(() => searchData.value.estimate, searchFetch);
watch(() => searchData.value.no_estimate, searchFetch);
watch(() => searchData.value.post_meeting_status, searchFetch);
watch(() => searchData.value.management_method, searchFetch);
watch(() => searchData.value.has_specific_skill, searchFetch);
watch(() => searchData.value.meeting_month, searchFetch);
watch(() => searchData.value.application_month, searchFetch);
watch(() => searchData.value.usage_status, searchFetch);
watch(() => searchData.value.cancellation_reason, searchFetch);
watch(() => searchData.value.download_document, searchFetch);
watch(() => searchData.value.download_month, searchFetch);

// 検索条件のクリア
function searchClear(name) {
	searchData.value[name] = "";
}

function searchAllClear() {
	searchData.value.keyword = "";
	searchData.value.type = [];
	searchData.value.status = "";
	searchData.value.call_result = "";
	searchData.value.estimate = "";
	searchData.value.no_estimate = "";
	searchData.value.post_meeting_status = "";
	searchData.value.management_method = "";
	searchData.value.has_specific_skill = "";
	searchData.value.meeting_month = "";
	searchData.value.application_month = "";
	searchData.value.usage_status = "";
	searchData.value.cancellation_reason = "";
	searchData.value.download_document = "";
	searchData.value.download_month = "";
}

watch(
	() => searchData.value.dateType,
	(newValue, oldValue) => {
		if (newValue == 1) {
			searchData.value.month = "";
			formatData.value = getCurrentDay();
		} else {
			searchData.value.day = "";
			formatData.value == "";
			getCurrentMonth();
		}
	}
);

// 当月の取得
function getCurrentMonth() {
	let date = new Date();
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	month = month.toString().padStart(2, "0");
	searchData.value.month = `${year}/${month}`;
}

// 当日の取得
function getCurrentDay() {
	if (formatData.value == "") {
		let date = new Date();
		searchData.value.day = moment(date).format("YYYY/MM/DD");
		return moment(date).format("YYYY/MM/DD");
	}
	const regex = /^\d{4}\/\d{2}\/\d{2}$/;
	if (regex.test(formatData.value)) {
		// 日付が既に「YYYY/MM/DD」形式の場合はそのまま
		searchData.value.day = formatData.value;
		return formatData.value;
	} else {
		// 日付が他の形式の場合はフォーマット
		searchData.value.day = moment(formatData.value).format("YYYY/MM/DD");
		return moment(formatData.value).format("YYYY/MM/DD");
	}
}
function searchMenuOpen(event) {
	isSearchMenuOpenFlag.value = event.target.open;
}
function searchMenuClose() {
	isSearchMenuOpenFlag.value = false;
}

/* ---------------------------------------------------------------------------
	ページ遷移
---------------------------------------------------------------------------- */
function pageMove(id) {
	if (id == "create") {
		sessionStorage.removeItem("saveList");
		router.push(`/sales/companies/create`);
	} else {
		saveListSession();
		router.push(`/sales/companies/${id}/edit`);
	}
}

/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	loadSearchDataFromSession();
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;

.table {
	width: 100%;
	table-layout: fixed;
	border-radius: 5px;
	background: $bg-white2;
	border-collapse: separate;
}
.table tr {
	cursor: pointer;
	@include trans(0.3);
	&:hover {
		background: #eaf1fa;
		@include trans(0.3);
	}
}
.table_title {
	font-size: 1.2rem;
	background: $bg-white2;
	padding: 15px 0.5rem;
	position: sticky;
	top: 199px;
	// z-index: 10;
	background: $bg-gray1;
}
.table_data {
	font-size: 1.3rem;
	padding: 15px 0.5rem;
	font-weight: normal;
	border-bottom: 1px dashed $bg-gray1;
}
.table_data_type {
	min-width: 50px;
	text-align: center;
	font-weight: bold;
	font-size: 1.2rem;
	border-radius: 5px;
	padding: 1px 6px;
	// background: #fde7eb;
	color: $color-red2;
	border: 1px solid $bg-red2;
	&.green {
		color: $color-green2;
		border-color: $bg-green2;
		// background: #edf7ee;
	}
	&.disabled {
		color: $color-gray2;
		background: $bg-white1;
		border-color: $bg-gray1;
	}
}
.table_data_clamp {
	overflow: hidden;
	display: -webkit-box;
	// white-space: nowrap;
	text-overflow: ellipsis;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
.table_data_link {
	color: $color-gray3;
	@include trans(0.3);
	&.color {
		color: $secondaryColor;
	}
	&:hover {
		color: $secondaryColor;
		@include trans(0.3);
	}
}

.searchButton {
	font-size: 1.2rem;
	padding: 8px;
	max-height: 40px;
	color: $color-white2;
	background: $bg-blue2;
	border: 1px solid $bg-blue2;
	border-radius: 5px;
	@include trans(0.3);
	&:hover {
		color: $color-blue2;
		background: $bg-white2;
		@include trans(0.3);
	}
	&.close {
		background: $bg-gray4;
		border-color: $bg-gray4;
		&:hover {
			color: $color-gray4;
			background: $bg-white2;
		}
	}
}

.staffIcon {
	background: $bg-red2;
	border-radius: 30px;
	color: $color-white2;
	padding: 2px 1px 2px 3px;
	font-size: 1.2rem;
	margin-right: 5px;
	&.green {
		background: $bg-green2;
	}
}
</style>
